import { render, staticRenderFns } from "./Acryl.vue?vue&type=template&id=48d065c2&scoped=true&"
import script from "./Acryl.vue?vue&type=script&lang=js&"
export * from "./Acryl.vue?vue&type=script&lang=js&"
import style0 from "./Acryl.vue?vue&type=style&index=0&id=48d065c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d065c2",
  null
  
)

export default component.exports